import React from 'react';

import EventRegistrationButton from 'buyside/components/presentation/EventPage/EventRegistrationButton/eventRegistrationButton';
import EventRegistrationButtonSubtitle from 'buyside/components/presentation/EventPage/EventRegistrationButtonSubtitle/eventRegistrationButtonSubtitle';
import FadeInContainer from 'buyside/components/presentation/FadeInContainer/fadeInContainer';

import styles from './eventDescriptionStyles.scss';

const EventDescription: React.FC<{ isLoggedIn: boolean }> = ({ isLoggedIn }) => (
  <div id="description" className={styles.descriptionContainer}>
    <div className={styles.logo}>
      <img src="/images/logo_darkbg_350.png" />
      <img src="/images/event/AS-LOGO-RGB-REV.png" />
    </div>
    <div className={styles.eventDescription}>
      <FadeInContainer>
        <div>
          Join SumZero and AlphaSense on May 28th at our Spring Investor Summit, for an exclusive,
          invite-only event bringing together the investment industry's most forward-thinking
          professionals. This premier gathering, sponsored by AlphaSense, marks the launch of a
          series of in-person and virtual stock pitch and networking events planned for 2025.
        </div>
      </FadeInContainer>
      <FadeInContainer>
        <div>
          This intimate buyside summit will welcome approximately 125 of the investment industry's
          brightest minds – buyside PMs, analysts, allocators and leading venture capitalists – for
          an afternoon of actionable investment insights and high-value networking.
        </div>
      </FadeInContainer>
      <FadeInContainer>
        <div>
          Hear from five leading investment managers as they present their highest-conviction
          opportunities. Learn from innovators like Jordan Fliegel (Techstars), Jason Shuman
          (Primary VC), Semyon Dukach (One Way Ventures) and Dorothy Chang (Flybridge) on venture
          capital trends shaping tomorrow’s markets. Build meaningful connections with some of the
          brightest minds in the field.
        </div>
      </FadeInContainer>
      <FadeInContainer>
        <div>
          Highlighting the day is keynote speaker Dan Rasmussen, Founder of Verdad Advisors and a
          long-standing SumZero member, who will share his unique insights into the evolving
          investment landscape. Be sure to reserve your spot now as space will be limited.
        </div>
      </FadeInContainer>
    </div>
    {isLoggedIn && <EventRegistrationButton />}
    <EventRegistrationButtonSubtitle />
  </div>
);

export default EventDescription;
